var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("JonInfo", {
        staticClass: "mb-4",
        scopedSlots: _vm._u([
          {
            key: "message",
            fn: function() {
              return [
                _c("p", [
                  _vm._v(
                    "\n\t\t\t\tGib eine Lebensstation ein, wie Job, Auszeit, Karenz oder ehrenamtliche Tätigkeit."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("b", [
                    _vm._v(
                      "Deine Texteingaben sind erst dann für einen bestimmten Arbeitgeber sichtbar, wenn du den Kontakt\n\t\t\t\t\tzu ihm bestätigt hast."
                    )
                  ])
                ])
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "sections" },
        [
          _c(
            "section",
            [
              _c("h3", [_vm._v(_vm._s(_vm.titles.startEnd))]),
              _vm._v(" "),
              _c("DateEdit", {
                on: { input: _vm.emitChangeEvent },
                model: {
                  value: _vm.startEnd,
                  callback: function($$v) {
                    _vm.startEnd = $$v
                  },
                  expression: "startEnd"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "section",
            [
              _c("h3", [_vm._v(_vm._s(_vm.titles.careerType))]),
              _vm._v(" "),
              _c("Select", {
                staticClass: "career-type-select",
                attrs: { options: _vm.careerTypeOptions },
                on: { change: _vm.careerTypeChanged },
                model: {
                  value: _vm.careerType,
                  callback: function($$v) {
                    _vm.careerType = $$v
                  },
                  expression: "careerType"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.careerType
            ? [
                _vm.companyNameEligible || _vm.companyWebsiteEligible
                  ? _c(
                      "b-row",
                      [
                        _vm.companyNameEligible
                          ? _c("b-col", { attrs: { md: "8" } }, [
                              _c(
                                "section",
                                { staticClass: "first-level-section" },
                                [
                                  _vm.computedCompanyNameTitle
                                    ? _c("h3", [
                                        _vm._v(
                                          _vm._s(_vm.computedCompanyNameTitle)
                                        )
                                      ])
                                    : _c("h3", [
                                        _vm._v("Name des Arbeitgebers "),
                                        _c("span", { staticClass: "sub" }, [
                                          _vm._v("(Organisation/Unternehmen)")
                                        ])
                                      ]),
                                  _vm._v(" "),
                                  _c("b-input", {
                                    attrs: { maxlength: "250" },
                                    on: { input: _vm.emitChangeEvent },
                                    model: {
                                      value: _vm.companyName,
                                      callback: function($$v) {
                                        _vm.companyName = $$v
                                      },
                                      expression: "companyName"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("LockInfo", { staticClass: "mt-2" }, [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\tWird einem Arbeitgeber erst dann angezeigt, wenn du deinen Lebenslauf zur Ansicht\n\t\t\t\t\t\t\tfreigibst.\n\t\t\t\t\t\t"
                                    )
                                  ])
                                ],
                                1
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.companyWebsiteEligible
                          ? _c("b-col", { attrs: { md: "4" } }, [
                              _c(
                                "section",
                                { staticClass: "first-level-section" },
                                [
                                  _c("h3", [
                                    _vm._v("Website "),
                                    _c("span", { staticClass: "sub" }, [
                                      _vm._v("(optional)")
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "FormGroup",
                                    [
                                      _c("b-input", {
                                        attrs: { maxlength: "250" },
                                        on: { input: _vm.emitChangeEvent },
                                        model: {
                                          value: _vm.companyWebsite,
                                          callback: function($$v) {
                                            _vm.companyWebsite = $$v
                                          },
                                          expression: "companyWebsite"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.titleEligible
                  ? _c(
                      "section",
                      [
                        _c("h3", [_vm._v(_vm._s(_vm.computedTitleTitle))]),
                        _vm._v(" "),
                        _c("b-input", {
                          attrs: { maxlength: "250" },
                          on: { input: _vm.emitChangeEvent },
                          model: {
                            value: _vm.title,
                            callback: function($$v) {
                              _vm.title = $$v
                            },
                            expression: "title"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "section",
                  [
                    _c("h3", [_vm._v(_vm._s(_vm.computedDescriptionTitle))]),
                    _vm._v(" "),
                    _vm.isDescriptionMandatory
                      ? _c(
                          "p",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.html",
                                modifiers: { html: true }
                              }
                            ],
                            staticClass:
                              "d-inline-block color-turquoise font-weight-extra-bold",
                            attrs: { title: _vm.descriptionPlaceholder }
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\tGib alle Details an, das erhöht deine Chancen!\n\t\t\t\t\t"
                            ),
                            _c("Icon", {
                              staticClass: "ml-1",
                              attrs: {
                                icon: "info",
                                color: "turquoise",
                                size: "1comma5x"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("Wysiwyg", {
                      attrs: { placeholder: _vm.descriptionPlaceholder },
                      on: { input: _vm.emitChangeEvent },
                      model: {
                        value: _vm.description,
                        callback: function($$v) {
                          _vm.description = $$v
                        },
                        expression: "description"
                      }
                    }),
                    _vm._v(" "),
                    _vm.descriptionError
                      ? _c(
                          "div",
                          { staticClass: "error font-size-smaller mt-1" },
                          [_vm._v(_vm._s(_vm.descriptionError))]
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.careerTypeJob
                  ? [
                      _c(
                        "section",
                        [
                          _c("h3", [
                            _vm._v(
                              "\n\t\t\t\t\t\t" +
                                _vm._s(_vm.titles.careerLevel) +
                                "\n\t\t\t\t\t\t"
                            ),
                            !_vm.isCareerLevelMandatory
                              ? _c("span", [_vm._v("(optional)")])
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("CharacteristicEdit", {
                            attrs: {
                              "edit-config": {
                                title: _vm.titles.careerLevel,
                                characteristicItems: _vm.meta.careerLevel,
                                characteristicType: _vm.meta.careerLevelType,
                                singleChoice: true
                              },
                              "open-fan-label": "Berufsebene wählen"
                            },
                            on: { input: _vm.emitChangeEvent },
                            model: {
                              value: _vm.careerLevel,
                              callback: function($$v) {
                                _vm.careerLevel = $$v
                              },
                              expression: "careerLevel"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "section",
                        [
                          _c("h3", [
                            _vm._v(
                              "\n\t\t\t\t\t\t" +
                                _vm._s(_vm.titles.functions) +
                                "\n\t\t\t\t\t\t"
                            ),
                            !_vm.isFunctionsMandatory
                              ? _c("span", [_vm._v("(optional)")])
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("CharacteristicEdit", {
                            attrs: {
                              "edit-config": {
                                title: _vm.titles.functions,
                                characteristicItems: _vm.meta.function,
                                characteristicType: _vm.meta.functionType,
                                supplementsConfig: {
                                  nothingAllowed: false,
                                  types: _vm.functionSupplementTypes
                                },
                                withKeyword: true,
                                searchConfig: {
                                  catalog: _vm.meta.searchCatalogFunction
                                }
                              },
                              "open-fan-label": "Tätigkeit(en) wählen"
                            },
                            on: { input: _vm.functionsChanged },
                            model: {
                              value: _vm.functions,
                              callback: function($$v) {
                                _vm.functions = $$v
                              },
                              expression: "functions"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.isIndustrialSectorEligible
                        ? _c(
                            "section",
                            [
                              _c("h3", [
                                _vm._v(
                                  "\n\t\t\t\t\t\t" +
                                    _vm._s(_vm.titles.industrialSectors) +
                                    "\n\t\t\t\t\t\t"
                                ),
                                !_vm.isIndustrialSectorsMandatory
                                  ? _c("span", [_vm._v("(optional)")])
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c("CharacteristicEdit", {
                                attrs: {
                                  "edit-config": {
                                    title: _vm.titles.industrialSectors,
                                    characteristicItems:
                                      _vm.meta.industrialSector,
                                    characteristicType:
                                      _vm.meta.industrialSectorType,
                                    withKeyword: true,
                                    searchConfig: {
                                      catalog:
                                        _vm.meta.searchCatalogIndustrialSector
                                    }
                                  },
                                  "open-fan-label": "Branche(n) wählen"
                                },
                                on: { input: _vm.emitChangeEvent },
                                model: {
                                  value: _vm.industrialSectors,
                                  callback: function($$v) {
                                    _vm.industrialSectors = $$v
                                  },
                                  expression: "industrialSectors"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isOrganisationAreaEligible
                        ? _c(
                            "section",
                            [
                              _c("h3", [
                                _vm._v(_vm._s(_vm.titles.organisationalArea))
                              ]),
                              _vm._v(" "),
                              _c("CharacteristicEdit", {
                                attrs: {
                                  "edit-config": {
                                    title: _vm.titles.organisationalArea,
                                    characteristicItems:
                                      _vm.organisationalAreaItems,
                                    characteristicType:
                                      _vm.meta.organisationalAreaType,
                                    supplementsConfig: {
                                      nothingAllowed: false
                                    },
                                    withKeyword: true
                                  },
                                  "open-fan-label":
                                    "Organisationsbereich(e) wählen"
                                },
                                on: { input: _vm.emitChangeEvent },
                                model: {
                                  value: _vm.organisationalArea,
                                  callback: function($$v) {
                                    _vm.organisationalArea = $$v
                                  },
                                  expression: "organisationalArea"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  : _vm._e()
              ]
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }